export default "__VITE_ASSET__iwLCsLN2__"